import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom';

import Layout from "./containers/Layout/Layout";
import 'bootstrap';
import './assets/sass/app.scss';

function App()
 {
  return (
      <Router>
        <Switch>
          <Route path="/" name="Dashboard" render={props => <Layout {...props}/>}/>
        </Switch>
      </Router>
  ); 
}

export default App;
